/**
 * Resource that represents an RFID Reader.
 *
 * @name RfidReader
 * @class
 * @augments TmrResource
 */
function RfidReaderFactory(TmrResource, Place, tmrRfidReaderTypes) {
  'ngInject'
  let referencedProperties = [
    // rfidReader.place property will be instantiated as a Place resource
    { property: 'place', resource: Place },
  ]
  let RfidReader = TmrResource('RfidReader', {}, referencedProperties)

  Object.assign(RfidReader, { getTypeDescription, getTypePorts, getTagType })
  Object.assign(RfidReader.prototype, {
    $getTypeDescription: getTypeDescription,
    $getTypePorts: getTypePorts,
    $getTagType: getTagType,
  })

  /**
   * Return RFID Reader type description.
   *
   * @method RfidReader#getTypeDescription
   */
  function getTypeDescription() {
    return this.type ? tmrRfidReaderTypes[this.type].label : null
  }

  /**
   * Return RFID Reader type number of ports.
   *
   * @method RfidReader#getTypePorts
   */
  function getTypePorts() {
    return this.type ? tmrRfidReaderTypes[this.type].ports : null
  }

  /**
   * Return RFID Reader gat type.
   *
   * @method RfidReader#getTagType
   */
  function getTagType() {
    return this.type ? tmrRfidReaderTypes[this.type].tagType : null
  }

  return RfidReader
}

export const factory = ['RfidReader', RfidReaderFactory]
